<template>
  <Flex>
    <Flex direction="column">
      <BaseLabel color="success">
        {{ $t('subscription.cancelation_flow.offer.savings_label', {
            amount: filters.currency(
              basePrice?.amountSubtotal ?? 0,
              basePrice?.currency ?? ''
            ),
            period: translatedPeriod
          }) }}
      </BaseLabel>
      <BaseHeading>
        {{ $t('subscription.cancelation_flow.offer.heading') }}
      </BaseHeading>
      <BaseText>
        {{ $t('subscription.cancelation_flow.offer.description', brandName()) }}
      </BaseText>
    </Flex>
    <img
      v-if="$screen !== 's'"
      src="/img/cancel-subscription/treatwell_offer.svg"
      :class="$style.image"
    >
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import filters from '@/filters';
import { brandName } from '@/helpers/brand-name';
import { useCurrentPlanQuote } from '@/modules/admin/billing/store';

const { t } = useI18n();
const { quote, basePrice } = storeToRefs(useCurrentPlanQuote());

const translatedPeriod = computed(() => {
  if (!quote.value?.period) return '';
  return t(`global.items.${quote.value.period.toLowerCase()}`);
});
</script>

<style
  lang="scss"
  module
>
.image {
  height: 185px;
  width: auto;
}
</style>
